import { Instagram, Phone, MapPin } from "lucide-react";

const LOGO_GOLD = "https://customer-assets.emergentagent.com/job_yago-aesthetic/artifacts/z0qrqptn_04.png";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-navy py-24 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-14 md:gap-8 mb-20">
          {/* Logo & tagline */}
          <div className="md:col-span-5">
            <img
              src={LOGO_GOLD}
              alt="Dr. Yago Almeida"
              className="h-16 w-auto mb-8 opacity-90"
              data-testid="footer-logo"
            />
            <p className="font-body text-white/60 text-sm leading-[1.85] max-w-[300px]">
              Excelência, segurança e resultados naturais. Cirurgia plástica com precisão técnica e olhar estético apurado.
            </p>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3">
            <h4 className="font-body text-white/70 text-[11px] font-semibold tracking-[0.25em] uppercase mb-8">
              Navegação
            </h4>
            <ul className="space-y-4">
              {[
                { label: "Procedimentos", href: "#procedimentos" },
                { label: "Sobre o Doutor", href: "#sobre" },
                { label: "Perguntas Frequentes", href: "#faq" },
                { label: "Localização", href: "#localizacao" },
                { label: "Contato", href: "#contato" },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="font-body text-white/55 text-sm hover:text-gold transition-colors duration-300"
                    data-testid={`footer-link-${link.href.replace("#", "")}`}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="font-body text-white/70 text-[11px] font-semibold tracking-[0.25em] uppercase mb-8">
              Contato
            </h4>
            <ul className="space-y-5">
              <li>
                <a
                  href="https://instagram.com/dryagoalmeida"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 font-body text-white/55 text-sm hover:text-gold transition-colors duration-300"
                  data-testid="footer-instagram"
                >
                  <Instagram size={15} />
                  @dryagoalmeida
                </a>
              </li>
              <li>
                <a
                  href="tel:+5551997410236"
                  className="flex items-center gap-3 font-body text-white/55 text-sm hover:text-gold transition-colors duration-300"
                  data-testid="footer-phone"
                >
                  <Phone size={15} />
                  (51) 99741-0236
                </a>
              </li>
              <li>
                <span className="flex items-start gap-3 font-body text-white/55 text-sm leading-relaxed">
                  <MapPin size={15} className="flex-shrink-0 mt-0.5" />
                  Moriá Saúde — Av. Adolfo Fetter, 3419 - 5, Laranjal, Pelotas/RS
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-10 flex flex-col sm:flex-row items-center justify-between gap-5">
          <p className="font-body text-white/45 text-xs tracking-wide">
            &copy; {new Date().getFullYear()} Dr. Yago Almeida — Cirurgia Plástica
            &nbsp;&middot;&nbsp;
            <a href="/privacidade" className="hover:text-gold transition-colors duration-300" data-testid="footer-privacy-link">Política de Privacidade</a>
          </p>
          <p className="font-body text-white/55 text-[11px] tracking-[0.08em] font-medium">
            CRM-RS 45316 &nbsp;&middot;&nbsp; RQE 41765 &nbsp;&middot;&nbsp; RQE 47594
          </p>
        </div>
      </div>
    </footer>
  );
};
